import { useState } from 'react';
import styled from 'styled-components';
import { rel8DarkPink, rel8Pink, rel8Purple, rel8White } from "../../globals";
import EditGalleryName from '../Modals/EditGalleryName';
import { EditProfileIcon } from '../../assets/SideBar/svgs';


const SubConHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;
`;

const AddButton = styled.button`
  background: #f0f0f0;
  padding: 8px 16px;
  border: 1px dashed #999;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 16px;
`;

const EditButton = styled.button`
  background-color: ${rel8Purple};
  color: ${rel8White};
  border: none;
  font-size: 14px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.2s;
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 4px;
  
  &:hover {
    background-color: ${rel8Pink};
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    color: ${rel8DarkPink};
  }
  &:active {
    transform: translateY(0);
  }
`;
const SubConHeader = styled.p`
  font-weight: 700;
  text-align: center;
  margin: 0;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;

const SubConBtnHold = styled.div`
    display: flex;
    justify-content: space-evenly;
    margin: 30px 0px;
`;

const SubConBtn = styled.button`
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    background-color: ${props=>props.typex==="filled" ? `${rel8Purple}`:`${rel8Pink}`};
    color: ${props=>props.typex==="filled" ? `${rel8White}`:`${rel8Purple}`};
    cursor: pointer;
`;

const SubConComponent = ({ data, setShowUpload, showUpload, deleteLoading, deleteGalleryHandler, close }) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [galleryName, setGalleryName] = useState(data.name);

  return (
    <>
      <SubConHeaderContainer>
        <SubConHeader>{galleryName}</SubConHeader>
        <EditButton onClick={() => setShowEditModal(true)}>
          <EditProfileIcon
            // svgClick={() => handleEdit(item)}
            style={{ cursor: "pointer", width: "14px", height: "14px" }}
          />
        </EditButton>
      </SubConHeaderContainer>
      <SubConBtnHold>
        <AddButton onClick={() => setShowUpload(!showUpload)}>+ Add More Images</AddButton>
        <SubConBtn typex="filled" disabled={deleteLoading} onClick={() => deleteGalleryHandler(data.id)}>
          Delete Gallery
        </SubConBtn>
        <SubConBtn onClick={close} disabled={deleteLoading}>Close</SubConBtn>
      </SubConBtnHold>

      <EditGalleryName
        isOpen={showEditModal}
        onClose={() => setShowEditModal(false)}
        onSave={setGalleryName}
        id={data.id}
        currentName={data.name}
      />
    </>
  );
};

export default SubConComponent;
